function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "inherit"
    },
    d: "M7.99334 1.33334C4.31334 1.33334 1.33334 4.32001 1.33334 8.00001C1.33334 11.68 4.31334 14.6667 7.99334 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00001C14.6667 4.32001 11.68 1.33334 7.99334 1.33334ZM10.1467 11.5933L8.00001 10.3L5.85334 11.5933C5.79718 11.6274 5.73223 11.6442 5.66659 11.6416C5.60095 11.639 5.53752 11.6172 5.48421 11.5788C5.4309 11.5404 5.39006 11.4872 5.36679 11.4258C5.34352 11.3643 5.33884 11.2974 5.35334 11.2333L5.92001 8.79334L4.03334 7.16001C3.98434 7.11636 3.94916 7.05933 3.93213 6.99594C3.91511 6.93256 3.91698 6.86558 3.93752 6.80324C3.95807 6.74091 3.99638 6.68594 4.04775 6.64509C4.09913 6.60425 4.16132 6.57931 4.22668 6.57334L6.72001 6.36001L7.69334 4.06001C7.80668 3.78668 8.19334 3.78668 8.30668 4.06001L9.28001 6.35334L11.7733 6.56668C11.839 6.57232 11.9015 6.59727 11.9529 6.63839C12.0044 6.67951 12.0425 6.73495 12.0624 6.79772C12.0824 6.86048 12.0833 6.92776 12.0651 6.99105C12.0469 7.05435 12.0103 7.11082 11.96 7.15334L10.0733 8.78668L10.64 11.2333C10.7067 11.52 10.4 11.7467 10.1467 11.5933Z",
    fill: "none"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.81d86310eca90f99b63a2b430ffbce33.svg";
export { ForwardRef as ReactComponent };